import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Admin } from "react-admin";
import { History } from "history";

import Layout from "../components/Layout";
import usePrepareApp from "../hooks/usePrepareApp";
import { authProvider, customDataProvider } from "../init/firebase";
import theme from "../theme/index";
import { ReduxState } from "../types/redux.types";
import { User, UserRole } from "../types/user.types";
import { getCurrentAccountResources } from "../utils/resources";
import Login from "./Login";

const Sporting: FC<SportingProps> = ({ history }) => {
  const [role, setRole] = useState(UserRole.admin);
  const user = useSelector<ReduxState, User>((state) => state.user);

  usePrepareApp();

  useEffect(() => {
    setRole(user.role);
  }, [user.role]);

  return (
    <Admin
      dataProvider={customDataProvider}
      authProvider={authProvider}
      history={history}
      layout={Layout}
      theme={theme}
      loginPage={Login}
      dashboard={getCurrentAccountResources(role).dashboard}
      customRoutes={getCurrentAccountResources(role).customRoutes}
    >
      {(permissions) => getCurrentAccountResources(permissions.role).resources}
    </Admin>
  );
};

interface SportingProps {
  history: History;
}

export default Sporting;
